var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataReady)?_c('div',{staticClass:"content"},[_c('big-one',{attrs:{"content":_vm.content,"type":_vm.type,"a-page":true,"tuning":true,"default-sort":'nextDate'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }